if (!customElements.get('aqila-bundle-atc-price')) {
  customElements.define(
    'aqila-bundle-atc-price',
    class AqilaBundleAtcPrice extends HTMLElement {
      connectedCallback() {
        if (this.bundleObserver || this.discoveryObserver) return;
        this.currentPrice = this.querySelector('[data-aqila-atc-current-price]');
        this.comparePrice = this.querySelector('[data-aqila-atc-compare-price]');
        this.button = this.closest('button[name="add"]');
        this.scope = this.closest('.product__info-container') || this.closest('section') || document;
        this.connectToBundle();
      }

      disconnectedCallback() {
        this.bundleObserver?.disconnect();
        this.discoveryObserver?.disconnect();
        this.bundleObserver = null;
        this.discoveryObserver = null;
        this.bundle = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      findBundle() {
        const productId = this.dataset.productId;
        if (!productId) return null;
        const selector = `kaching-bundle[product-id="${CSS.escape(productId)}"]`;
        return this.scope.querySelector(selector) || document.querySelector(selector);
      }

      connectToBundle() {
        const bundle = this.findBundle();
        if (!bundle) {
          this.discoveryObserver = new MutationObserver(() => {
            const discoveredBundle = this.findBundle();
            if (!discoveredBundle) return;
            this.discoveryObserver.disconnect();
            this.observeBundle(discoveredBundle);
          });
          this.discoveryObserver.observe(this.scope, { childList: true, subtree: true });
          return;
        }
        this.observeBundle(bundle);
      }

      observeBundle(bundle) {
        this.bundle = bundle;
        this.update();
        this.bundleObserver = new MutationObserver(() => this.scheduleUpdate());
        this.bundleObserver.observe(bundle, {
          attributes: true,
          attributeFilter: ['aria-checked', 'class'],
          characterData: true,
          childList: true,
          subtree: true,
        });
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const selectedOffer = this.bundle?.querySelector(
          '.kaching-bundles__bars--plain > .kaching-bundles__bar--selected'
        );
        const price = selectedOffer?.querySelector('.kaching-bundles__bar-price')?.textContent?.trim();
        const compare = selectedOffer?.querySelector('.kaching-bundles__bar-full-price')?.textContent?.trim();

        if (!price || this.button?.disabled) {
          this.hidden = true;
          return;
        }

        this.currentPrice.textContent = price;
        this.comparePrice.textContent = compare || '';
        this.comparePrice.hidden = !compare || compare === price;
        this.hidden = false;
      }
    }
  );
}

// Kaching peut désélectionner l'offre active lorsqu'elle est recliquée. Le bundle
// doit toujours conserver exactement une offre sélectionnée afin que la variante,
// le selling plan et le prix du CTA restent synchronisés.
if (!window.__aqilaBundleSelectedOfferGuard) {
  window.__aqilaBundleSelectedOfferGuard = true;

  document.addEventListener(
    'click',
    (event) => {
      const selectedOffer = event.target.closest(
        'kaching-bundle .kaching-bundles__bars--plain > .kaching-bundles__bar--selected'
      );
      if (!selectedOffer) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
}
